import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
//@ts-ignore
import { Smile, Sticker } from "lucide-react";
import { useTheme } from "@/providers/theme-provider";
import { useTranslation } from "@/providers/language-provider";
import { useState } from "react";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import StickerPicker from "@/components/blocks/sticker-picker";

//@ts-ignore
const styleExpressionItem = "text-foreground";
//@ts-ignore
const styleExpressionItemMuted = "text-muted-foreground";

export function ExpressionPicker({
  onSelect,
}: {
  onSelect: (value: { type: string; value: string }) => void;
}) {
  const { theme } = useTheme();
  //@ts-ignore
  const { t, language } = useTranslation();
  //@ts-ignore
  const [expression, setExpression] = useState<string>("Emoji");

  const renderPicker = () => {
    if (expression === "Emoji") {
      return (
        <Picker
          data={data}
          onEmojiSelect={(emoji: any) =>
            onSelect({
              type: "Emoji",
              value: emoji.native,
            })
          }
          theme={theme}
          locale={language}
          autoFocus={false}
          skinTonePosition="none"
          previewPosition="none"
          set="native"
        />
      );
    } else if (expression === "Sticker") {
      return <StickerPicker />;
    }

    console.error("Unknown expression:", expression);
    return null;
  };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" title="Add Expression" tabIndex={-1}>
          <Smile className="h-4 w-4 mr-1" />
          {t("Emoji")}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-fit p-0" align="start">
        {renderPicker()}
        <div className="flex p-1 justify-between border-t-2">
          <Button
            variant="ghost"
            title="Add Emoji"
            onClick={() => setExpression("Emoji")}
            className={
              expression === "Emoji"
                ? styleExpressionItem
                : styleExpressionItemMuted
            }
            tabIndex={-1}
          >
            <Smile className="h-4 w-4 mr-2" /> {t("Emoji")}
          </Button>
          <Button
            variant="ghost"
            title="Add Sticker"
            onClick={() => setExpression("Sticker")}
            className={
              expression === "Sticker"
                ? styleExpressionItem
                : styleExpressionItemMuted
            }
            tabIndex={-1}
          >
            <Sticker className="h-4 w-4 mr-2" /> {t("Sticker")}
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
